import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const STATE_IDENTIFIER = {
  TEMPLATE_TICKET: "TEMPLATE_TICKET",
  TEMPLATE_TICKET_FIELDS: "TEMPLATE_TICKET_FIELDS",
  SERVICE_REQ: "SERVICE_REQ",
  SERVICE_REQ_FIELDS: "SERVICE_REQ_FIELDS",
  EXTERNAL_FIELDS: "EXTERNAL_FIELDS",
  FIELDS_TYPE: "FIELDS_TYPE",
  TEMPLATE_T_DEL_STATE: "TEMPLATE_T_DEL_STATE",
  TEMPLATE_T_ADD_EDIT_STATE: "TEMPLATE_T_ADD_EDIT_STATE",
  TEMPLATE_T_FIELDS_DEL_STATE: "TEMPLATE_T_FIELDS_DEL_STATE",
  TEMPLATE_T_FIELDS_ADD_EDIT_STATE: "TEMPLATE_T_FIELDS_ADD_EDIT_STATE",
  SERVICE_REQ_DEL_STATE: "SERVICE_REQ_DEL_STATE",
  SERVICE_REQ_ADD_EDIT_STATE: "SERVICE_REQ_ADD_EDIT_STATE",
  SERVICE_REQ_FIELDS_DEL_STATE: "SERVICE_REQ_FIELDS_DEL_STATE",
  SERVICE_REQ_FIELDS_ADD_EDIT_STATE: "SERVICE_REQ_FIELDS_ADD_EDIT_STATE",
  EXTERNAL_FIELDS_DEL_STATE: "EXTERNAL_FIELDS_DEL_STATE",
  EXTERNAL_FIELDS_ADD_EDIT_STATE: "EXTERNAL_FIELDS_ADD_EDIT_STATE",
};

export const SERVICE_REQUEST_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_SERVICE_REQUEST_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_SERVICE_REQUEST_MGMT}/stepTwo`,
};

export interface ITemplateTicketProp {
  dataSource: ITemplateTicket[];
  responseDelete: IResponseState;
  responseAddEdit: IResponseState;
  getTemplateTicket: () => void;
  sendUpdate: (data: any) => void;
  sendNew: (data: any) => void;
  deleteTT: (ids: any) => void;
  resetState: () => void;
}

export interface ITemplateTicketGet {
  responseCode: number;
  responseStatus: string;
  templatesTicket: ITemplateTicket[];
}

export interface ITemplateTicket {
  idTicketTemplate: string;
  idServiceRequest: string;
  ticketSystemId: string;
}

export interface ITemplateTicketFieldsProp {
  dataSource: ITemplateTicketFieldUnique[];
  responseDelete: IResponseState;
  responseAddEdit: IResponseState;
  getTemplateTicketFields: () => void;
  sendUpdate: (data: any) => void;
  deleteTTF: (ids: any) => void;
  resetState: () => void;
}

export interface ITemplateTicketFieldUnique {
  idTemplate: string;
  fieldName: string;
  fieldValue: string;
  uniqueId: string;
}

export interface ITemplateTicketField {
  idTemplate: string;
  fieldName: string;
  fieldValue: string;
}

export interface IServiceReqProp {
  dataSource: IServiceReq[];
  responseDelete: IResponseState;
  responseAddEdit: IResponseState;
  getServiceReq: () => void;
  sendUpdate: (data: any) => void;
  deleteSR: (ids: any) => void;
  resetState: () => void;
}

export interface IServiceReq {
  serviceRequestId: number;
  serviceRequestName: string;
  displayOrder: number;
  fields: ISRFields[];
}

export interface ISRFields {
  idServiceRequest: number;
  serviceRequestName: string;
  fieldName: string;
  idField: number;
  fieldType: string;
  displayOrder: number;
  values: ISRFieldValue[];
}

export interface ISRFieldValue {
  idExternal: number;
  idField: number;
  fieldValue: string;
  displayOrder: number;
}

export interface IServiceReqUnfield {
  serviceRequestId: number;
  serviceRequestName: string;
  displayOrder: number;
  flag?: boolean;
}

export interface IServiceReqFieldsProp {
  dataSource: IServiceReqFields[];
  responseDelete: IResponseState;
  responseAddEdit: IResponseState;
  getServiceReqFields: () => void;
  sendUpdate: (data: any) => void;
  deleteSRF: (ids: any) => void;
  resetState: () => void;
}

export interface IServiceReqFields extends IServiceReqFieldsToSend {
  serviceRequestName: string;
  values: IServiceReqValues[];
}

export interface IServiceReqFieldsToSend {
  idServiceRequest: number;
  fieldName: string;
  idField: number;
  fieldType: string;
  displayOrder: number;
}

export interface IServiceReqValues {
  idExternal: number;
  idField: number;
  fieldValue: string;
  displayOrder: number;
}

export interface IExtFieldsProp {
  dataSource: IExtField[];
  responseDelete: IResponseState;
  responseAddEdit: IResponseState;
  getExternalFields: () => void;
  sendUpdate: (data: any) => void;
  sendNew: (data: any) => void;
  deleteEF: (ids: any) => void;
  resetState: () => void;
}

export interface IExtField extends IExtFieldToSend {
  fieldName: string;
  fieldId: number;
  serviceRequestId: number;
  serviceRequestName: string;
}

export interface IExtFieldToSend {
  idExternal: number;
  idField: number;
  fieldValue: string;
  displayOrder: number;
}
